import React from 'react';
import PropTypes from 'prop-types';
import { getUrlWithSize } from '../../../../utils/urls';

function PremiumItem (props) {
  /** @var PremiumAnnouncement item */
  const item = props.data;

  return (
    <div className='announcement premium-item'>
      <a href={item.getLink()}>
        <img src={getUrlWithSize(item.getMainPhoto(), '360x185')} />
        <div className='premium-item__content'>
          <div className='type'>{item.getType() && item.getType().get('fullName')}{item.getTotalArea() && ', ' + item.getTotalArea().getLabel('')}</div>
          <div className='address'>{item.getAddress()}</div>
          <div className='price'>{item.getPrice() && item.getPrice().getLabel()}</div>
        </div>
      </a>
    </div>
  );
}

PremiumItem.propTypes = {
  data: PropTypes.object.isRequired
};

PremiumItem.defaultProps = {};

export default PremiumItem;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/CardItems/PremiumItem.jsx